import { warning } from "@jutro/logger";
import { logDeprecationMessage } from "@jutro/platform";
export default function loadGA(trackingId) {
  if (logDeprecationMessage("Google Analytics (Universal Analytics)", "Google Analytics 4"), !trackingId) return warning("To enable GA provide tracking id"), null;
  var options,
    i,
    s,
    o,
    g,
    r,
    a,
    m,
    gaAddress,
    ga = (gaAddress = "https://www.google-analytics.com/analytics.js", null != options && options.gaAddress ? gaAddress = options.gaAddress : null != options && options.debug && (gaAddress = "https://www.google-analytics.com/analytics_debug.js"), i = window, s = document, o = "script", g = gaAddress, r = "ga", i.GoogleAnalyticsObject = r, i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date(), a = s.createElement(o), m = s.getElementsByTagName(o)[0], a.async = 1, a.src = g, m.parentNode.insertBefore(a, m), i[r], function () {
      var _window;
      return (_window = window).ga.apply(_window, arguments);
    });
  return ga("create", trackingId, "auto"), ga;
}